export const TooltipStyles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginTop: '10px',
    width: 'fit-content',
  },
};
